import {gql} from "@apollo/client/core";

const getParticipantLists = gql`
	query getParticipantsGroup($page: Float) {
		getParticipantsGroup(page: $page) {
		  participants_group {
		    group_id
		    group_name
		    active
		    created_at
		    updated_at
		    deleted_at
		    total_participants_count
		    editable
		  },
		  total
		}
	}
`;

const getListParticipants = gql`
 query getParticipantsList($page: Float, $group_id: Float!) {
		getParticipantsList(page: $page, group_id: $group_id) {
		  participants_group_list {
		    id
		    group_id
		    email
		    tags
		    created_at
		    updated_at
		    deleted_at
		    active
		  },
		  total
		}
	}
`;

export {
  getParticipantLists,
  getListParticipants
}